import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as CollateralDataQualityRoute } from '~/core/routes/collateral-data-quality/_index';

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsCollateralDataMonitoringPermissions;
};

export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /collateral-data-quality/*
  children: [
    { index: true, element: <CollateralDataQualityRoute /> },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
